(() => {
  function measureWidth(el) {
    return el.getBoundingClientRect().width;
  }

  function stripEditorAttrs(node) {
    if (!node) return;
    if (node instanceof Element) {
      Array.from(node.attributes).forEach((attr) => {
        if (attr.name.indexOf('data-shopify') === 0 || attr.name === 'data-aid') {
          node.removeAttribute(attr.name);
        }
      });
    }
    if (node.querySelectorAll) {
      node.querySelectorAll('*').forEach((el) => {
        Array.from(el.attributes).forEach((attr) => {
          if (attr.name.indexOf('data-shopify') === 0 || attr.name === 'data-aid') {
            el.removeAttribute(attr.name);
          }
        });
      });
    }
  }

  function afterPaint(callback) {
    requestAnimationFrame(() => {
      requestAnimationFrame(callback);
    });
  }

  function fillMarquee(marquee) {
    const track = marquee.querySelector('.ms__marquee-track');
    const group = marquee.querySelector('[data-ms-marquee-group]');
    if (!track || !group || !group.children.length) return;

    const targetWidth = Math.max(
      marquee.clientWidth,
      measureWidth(marquee),
      (marquee.closest('[data-ms]') || document.documentElement).clientWidth,
      320
    );
    if (targetWidth < 40) return;

    if (!marquee._msMarqueeSeed) {
      const unique = [];
      const seen = {};
      const separator = marquee.getAttribute('data-ms-marquee-sep');
      Array.from(group.querySelectorAll('.ms__marquee-item')).forEach((item) => {
        const text = (item.textContent || '').trim();
        if (!text || seen[text]) return;
        seen[text] = true;
        const itemClone = item.cloneNode(true);
        stripEditorAttrs(itemClone);
        unique.push(itemClone);
        if (separator) {
          const sep = document.createElement('span');
          sep.className = 'ms__marquee-sep';
          sep.textContent = separator;
          unique.push(sep);
        }
      });
      marquee._msMarqueeSeed = unique;
    }

    const seed = marquee._msMarqueeSeed;
    if (!seed.length) return;

    track.style.animationName = 'none';

    Array.from(track.querySelectorAll('.ms__marquee-group')).forEach((node, index) => {
      if (index > 0) node.remove();
    });

    group.innerHTML = '';
    seed.forEach((node) => group.appendChild(node.cloneNode(true)));

    let guard = 0;
    let lastWidth = 0;
    while (measureWidth(group) < targetWidth && guard < 60) {
      seed.forEach((node) => group.appendChild(node.cloneNode(true)));
      const nextWidth = measureWidth(group);
      if (nextWidth <= lastWidth + 0.5) break;
      lastWidth = nextWidth;
      guard += 1;
    }

    const duplicate = group.cloneNode(true);
    stripEditorAttrs(duplicate);
    duplicate.removeAttribute('data-ms-marquee-group');
    duplicate.setAttribute('aria-hidden', 'true');
    track.appendChild(duplicate);

    void track.offsetWidth;
    track.style.animationName = '';
  }

  function initMarquee(root) {
    root.querySelectorAll('[data-ms-marquee]').forEach((marquee) => {
      if (marquee.dataset.msMarqueeReady === '1') return;
      marquee.dataset.msMarqueeReady = '1';

      const build = () => fillMarquee(marquee);
      afterPaint(build);

      if (typeof ResizeObserver !== 'undefined') {
        let frame = 0;
        const observer = new ResizeObserver(() => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(build);
        });
        observer.observe(marquee);
        observer.observe(root);
      }

      window.addEventListener('load', build, { once: true });
    });
  }

  function initSection(root) {
    if (!root || root.dataset.msReady === '1') return;
    root.dataset.msReady = '1';
    initMarquee(root);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-ms]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => {
    scan(event.target);
  });
})();
